"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Face = void 0;
var Angry_1 = require("./Angry");
var Blank_1 = require("./Blank");
var Calm_1 = require("./Calm");
var Cheeky_1 = require("./Cheeky");
var Concerned_1 = require("./Concerned");
var Contempt_1 = require("./Contempt");
var Cute_1 = require("./Cute");
var Driven_1 = require("./Driven");
var EatingHappy_1 = require("./EatingHappy");
var EyesClosed_1 = require("./EyesClosed");
var OldAged_1 = require("./OldAged");
var Serious_1 = require("./Serious");
var Smile_1 = require("./Smile");
var Solemn_1 = require("./Solemn");
var Suspicious_1 = require("./Suspicious");
var Tired_1 = require("./Tired");
var VeryAngry_1 = require("./VeryAngry");
var Awe_1 = require("./Awe");
var ConcernedFear_1 = require("./ConcernedFear");
var Cyclops_1 = require("./Cyclops");
var Explaining_1 = require("./Explaining");
var Fear_1 = require("./Fear");
var Hectic_1 = require("./Hectic");
var LoveGrin_1 = require("./LoveGrin");
var LoveGrinTeeth_1 = require("./LoveGrinTeeth");
var Monster_1 = require("./Monster");
var Rage_1 = require("./Rage");
var SmileBig_1 = require("./SmileBig");
var SmileLol_1 = require("./SmileLol");
var SmileTeeth_1 = require("./SmileTeeth");
var CalmNM_1 = require("./CalmNM");
var SmileNM_1 = require("./SmileNM");
var CheersNM_1 = require("./CheersNM");
exports.Face = {
    Angry: Angry_1.Angry,
    Blank: Blank_1.Blank,
    Calm: Calm_1.Calm,
    Cheeky: Cheeky_1.Cheeky,
    Concerned: Concerned_1.Concerned,
    Contempt: Contempt_1.Contempt,
    Cute: Cute_1.Cute,
    Driven: Driven_1.Driven,
    EatingHappy: EatingHappy_1.EatingHappy,
    EyesClosed: EyesClosed_1.EyesClosed,
    OldAged: OldAged_1.OldAged,
    Serious: Serious_1.Serious,
    Smile: Smile_1.Smile,
    Solemn: Solemn_1.Solemn,
    Suspicious: Suspicious_1.Suspicious,
    Tired: Tired_1.Tired,
    VeryAngry: VeryAngry_1.VeryAngry,
    Awe: Awe_1.Awe,
    ConcernedFear: ConcernedFear_1.ConcernedFear,
    Cyclops: Cyclops_1.Cyclops,
    Explaining: Explaining_1.Explaining,
    Fear: Fear_1.Fear,
    Hectic: Hectic_1.Hectic,
    LoveGrin: LoveGrin_1.LoveGrin,
    LoveGrinTeeth: LoveGrinTeeth_1.LoveGrinTeeth,
    Monster: Monster_1.Monster,
    Rage: Rage_1.Rage,
    SmileBig: SmileBig_1.SmileBig,
    SmileLol: SmileLol_1.SmileLol,
    SmileTeeth: SmileTeeth_1.SmileTeeth,
    CalmNM: CalmNM_1.CalmNM,
    SmileNM: SmileNM_1.SmileNM,
    CheersNM: CheersNM_1.CheersNM
};
